// extracted by mini-css-extract-plugin
module.exports = {"common":"index_common__2JeWK","child":"index_child___zQnq","childCurrency":"index_childCurrency__2FkgG","header":"index_header__2-BFt"};